function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { connect } from 'react-redux';
import React, { Component } from 'react';
import RPT from 'prop-types';
/**
 * Decorator functionality for any react component
 * @param {Node} WrappedComponent A React component to be wrapped
 * @returns {Node} An wrapper for the original component which has all translate methods as props
 */

export default function decorate(WrappedComponent) {
  var _class, _temp;
  var WrappedConnectedComponent = connect(function (state, ownProps) {
    return {
      messages: state[ownProps.translate.config.reduxRoot].get('messages')
    };
  })(WrappedComponent);
  return _temp = _class = /*#__PURE__*/
  function (_Component) {
    _inherits(Translate, _Component);
    function Translate() {
      _classCallCheck(this, Translate);
      return _possibleConstructorReturn(this, _getPrototypeOf(Translate).apply(this, arguments));
    }
    _createClass(Translate, [{
      key: "getTranslateMethods",
      value: function getTranslateMethods() {
        var translate = this.context.translate;
        var msg = translate.msg,
          cnt = translate.cnt,
          config = translate.config,
          parseInteger = translate.parseInteger,
          formatDate = translate.formatDate,
          numberTo = translate.numberTo,
          numberToCurrency = translate.numberToCurrency,
          preciseNumberToCurrency = translate.preciseNumberToCurrency,
          numberToPercentage = translate.numberToPercentage,
          numberToRounded = translate.numberToRounded,
          selectedLocale = translate.selectedLocale,
          messages = translate.messages;
        return {
          msg: msg,
          cnt: cnt,
          config: config,
          parseInteger: parseInteger,
          formatDate: formatDate,
          numberTo: numberTo,
          numberToCurrency: numberToCurrency,
          preciseNumberToCurrency: preciseNumberToCurrency,
          numberToPercentage: numberToPercentage,
          numberToRounded: numberToRounded,
          translate: translate,
          translateSelectedLocale: selectedLocale(),
          translateMessages: messages()
        };
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedConnectedComponent, _extends({}, this.getTranslateMethods(), this.props));
      }
    }]);
    return Translate;
  }(Component), _defineProperty(_class, "displayName", "Translate(".concat(WrappedComponent && (WrappedComponent.displayName || WrappedComponent.name) || 'Component', ")")), _defineProperty(_class, "contextTypes", {
    translate: RPT.object
  }), _temp;
}